// components/rate/index.js
Component({
  /**
   * 外部样式类
   */
  externalClasses: ['custom-class'],
  /**
   * 组件的属性列表
   */
  properties: {
    name: {
      type: String,
      value: 'fade'
    },
    customStyle: String,
    show: {
      type: Boolean,
      value: true,
      observer: 'observeShow'
    },
    duration: {
      type: Number,
      value: 300
    }
  },

  /**
   * 组件的初始数据
   */
  data: {
    type: '',
    inited: false,
    display: false,
    supportAnimation: true
  },
  /**
   * 在组件实例进入页面节点树时执行
   */
  attached () {
    if (this.data.show) {
      this.show()
    }
    this.detectSupport()
  },

  /**
   * 组件的方法列表
   */
  methods: {
    detectSupport () {
      wx.getSystemInfo({
        success: info => {
          if (info && info.system && info.system.indexOf('iOS 8') === 0) {
            this.setData({ supportAnimation: false })
          }
        }
      })
    },
    /**
     * 监听show
     * @param {Boolean} value show的值
     */
    observeShow (value) {
      if (value) {
        this.show()
      } else {
        if (this.data.supportAnimation) {
          this.setData({ type: 'leave' })
        } else {
          this.setData({ display: false })
        }
      }
    },
    /**
     * 显示组件
     */
    show () {
      this.setData({
        inited: true,
        display: true,
        type: 'enter'
      })
    },
    /**
     * 动画结束
     */
    onAnimationEnd () {
      if (!this.data.show) {
        this.setData({
          display: false
        })
      }
    }
  }
})
